var _mask, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChat = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 17,
  fill: "none",
  viewBox: "0 0 16 17"
}, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "chat_svg__a",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M6.619 1.646a5.753 5.753 0 0 0-2.61 10.88v2.327a.5.5 0 0 0 .817.386l2.534-2.088h2.022a5.753 5.753 0 1 0 0-11.505z",
  clipRule: "evenodd"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M4.008 12.526h1.1v-.674l-.6-.306zm.818 2.713-.7-.849zm2.534-2.088v-1.1h-.395l-.305.25zM1.966 7.398a4.653 4.653 0 0 1 4.653-4.652v-2.2A6.853 6.853 0 0 0-.234 7.398zm2.542 4.148a4.65 4.65 0 0 1-2.542-4.148h-2.2a6.85 6.85 0 0 0 3.742 6.108zm.6 3.307v-2.327h-2.2v2.327zm-.981-.463a.6.6 0 0 1 .981.463h-2.2c0 1.353 1.574 2.095 2.618 1.235zm2.533-2.088L4.127 14.39l1.399 1.698 2.534-2.089zm2.722-.251H7.36v2.2h2.022zm4.652-4.653a4.653 4.653 0 0 1-4.652 4.653v2.2a6.853 6.853 0 0 0 6.852-6.853zM9.382 2.746a4.653 4.653 0 0 1 4.652 4.652h2.2A6.853 6.853 0 0 0 9.382.546zm-2.763 0h2.763v-2.2H6.619z",
  mask: "url(#chat_svg__a)"
})));
export { SvgChat as ReactComponent };